import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useOrderCheckoutDetails = (preId: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // //console.log("useOrderCreatemethodcontext---------", context.useApiError);
  const { set: setError } = useApiError();
  // Shared ref holding the response from the API
  const result = sharedRef(null, `useOrderCreate-${preId}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useOrderCreate-loading-${preId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useOrderCreate-error-${preId}`);

  // 发起支付
  const getDetails = async (customQuery) => {
    try {
      loading.value = true;
      // console.log("pay参数---------", customQuery);
      const res = await context.$xbuy.api.orderCheckoutDetails(customQuery);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value = null;
      } else {
        if (res.code !== 9820) {
          setError({ code: res.code, message: res.message });
          error.value = res.message;
          result.value = null;
        }
      }
    } catch (err) {
      error.value = err.message;
      result.value = null;

    } finally {
      loading.value = false;
    }
  };

  return {
    getDetails,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
